import { LEAVE_CHANNEL, START_CHANNEL_LISTENING } from './mutation-types';
import ws from '@shared/js/websocket/websocket-client';

export default {
	startListening({ commit }, { channel, event, callback }) {
		const subscription = ws.subscribe({ channel, event, callback });
		commit(START_CHANNEL_LISTENING, { channelName: channel, eventName: event, subscription });
		return subscription;
	},
	leaveChannel({ commit, state }, { channel }) {
		state.activeChannels
			.filter(activeChannel => activeChannel.name === channel)
			.forEach(activeChannel => ws.unsubscribe(activeChannel.subscription));
		commit(LEAVE_CHANNEL, { channelName: channel });
	},
};
